export function validateLithuaniaIdCard(value: string) {
    return Boolean(value) && value.length < 8;
}
